import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { Building2, Save } from 'lucide-react';

const CompanyInfoTab = ({ authAxios }) => {
  const [companyInfo, setCompanyInfo] = useState({
    name: 'Aureate Residences Ltd.', tagline: 'Accommodate. Operate. Manage.',
    description: 'Property and accommodation solutions built around genuine demand.',
    website: 'aureate-resident.com'
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      try {
        const response = await authAxios.get('/admin/settings');
        if (response.data.company_info) setCompanyInfo(response.data.company_info);
      } catch (error) {
        console.error('Failed to fetch company info:', error);
      }
    };
    fetch();
  }, [authAxios]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await authAxios.put('/admin/company-info', companyInfo);
      toast.success('Company information saved successfully!');
    } catch (error) {
      toast.error('Failed to save company information');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-2xl space-y-6" data-testid="company-info-tab">
      <div className="bg-[#111111] border border-white/5 p-6">
        <h2 className="font-mono font-bold mb-6 flex items-center gap-2">
          <Building2 className="w-5 h-5 text-[#D4AF37]" />
          Company Information
        </h2>
        <div className="space-y-4">
          <div>
            <label className="text-white/50 text-xs font-mono uppercase block mb-2">Company Name</label>
            <input type="text" value={companyInfo.name} onChange={(e) => setCompanyInfo({...companyInfo, name: e.target.value})} className="w-full bg-[#0A0A0A] border border-white/10 px-4 py-3 font-mono text-sm focus:border-[#D4AF37] outline-none" />
          </div>
          <div>
            <label className="text-white/50 text-xs font-mono uppercase block mb-2">Tagline</label>
            <input type="text" value={companyInfo.tagline} onChange={(e) => setCompanyInfo({...companyInfo, tagline: e.target.value})} className="w-full bg-[#0A0A0A] border border-white/10 px-4 py-3 font-mono text-sm focus:border-[#D4AF37] outline-none" />
          </div>
          <div>
            <label className="text-white/50 text-xs font-mono uppercase block mb-2">Description</label>
            <textarea value={companyInfo.description} onChange={(e) => setCompanyInfo({...companyInfo, description: e.target.value})} rows={3} className="w-full bg-[#0A0A0A] border border-white/10 px-4 py-3 font-mono text-sm focus:border-[#D4AF37] outline-none resize-none" />
          </div>
          <div>
            <label className="text-white/50 text-xs font-mono uppercase block mb-2">Website</label>
            <input type="text" value={companyInfo.website} onChange={(e) => setCompanyInfo({...companyInfo, website: e.target.value})} className="w-full bg-[#0A0A0A] border border-white/10 px-4 py-3 font-mono text-sm focus:border-[#D4AF37] outline-none" />
          </div>
          <button onClick={handleSave} disabled={saving} data-testid="save-company-info" className="flex items-center gap-2 px-6 py-3 bg-[#D4AF37] text-black font-mono text-sm hover:bg-[#D4AF37]/90 transition-colors disabled:opacity-50">
            <Save className="w-4 h-4" />{saving ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompanyInfoTab;
